import { Injectable } from '@angular/core';

export const sKey = {
	isGuestUser: 'isGuestUser',
	mwHelp: 'mwHelp',
	olHelp: 'olHelp',
	sdHelp: 'sdHelp',
	loggedIn: 'loggedIn',
	funds: 'funds',
	defaultIsin: 'defaultIsin',
	sortStore: 'SORT_STORE',
	marketMapFilters: 'MARKET_MAP_FILTERS',
	optionMarketMapFilters: 'OPTION_MARKET_MAP_FILTERS',
	bankGateways: 'BankGateways',
	setting: 'settings',
	symbol: 'all-symbols'
};
@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	setItem(key: string, value: string) {
		localStorage.setItem(key, value);
	}

	getItem(key: string): string {
		return localStorage.getItem(key);
	}

	removeItem(key: string): void {
		localStorage.removeItem(key);
	}
}
